import { TimelineEvent, TimelineEventType } from 'screens/Activity/Types'
import { ArticleMeta, GeneratePrompt } from 'types'
import dayjs from 'dayjs'
import { ArticleAIGeneratedEvent } from 'components/ActivityEvent/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { AUDIO_FOCUS, CAMPAIGN_FOCUS } from 'components/Wizards/TurnInto/TurnIntoWizard'

export const NON_RENAMABLE_EVENT_TYPES = [
  TimelineEventType.CommentsGroup,
  TimelineEventType.RepliesGroup,
  TimelineEventType.ArticleLastViewed,
]

export const RESTOREABLE_EVENT_TYPES = [
  TimelineEventType.EditsGroup,
  TimelineEventType.ArticleMerged,
  TimelineEventType.ArticleSuggestionApprovedAndMerged,
  TimelineEventType.ArticleReviewRequestApprovedAndMerged,
]

export const canRenameEvent = (event: TimelineEvent) => !NON_RENAMABLE_EVENT_TYPES.includes(event.type)
export const canRestoreEvent = (event: TimelineEvent) => RESTOREABLE_EVENT_TYPES.includes(event.type)

export const getDisabledActionsForEvent = (event: TimelineEvent, articleMeta?: ArticleMeta | null) => {
  const disabledActions = new Set<string>([])

  if (!canRenameEvent(event)) {
    disabledActions.add('rename')
  }
  if (event.is_current || !canRestoreEvent(event)) {
    disabledActions.add('restore')
  }
  if (!!articleMeta?.master_branch) {
    disabledActions.add('branch')
  }

  return disabledActions
}

export const shouldRenderPrompt = (prompt: string | undefined | null) => {
  if (!prompt) {
    return false
  }
  return !prompt.startsWith(AUDIO_FOCUS) && !prompt.startsWith(CAMPAIGN_FOCUS)
}

export const displayTimestamp = (timestamp: string) => dayjs(timestamp).format('h:mma')

export const eventPromptText = (event: ArticleAIGeneratedEvent) => promptText(event.data as GeneratePrompt)

export const promptText = (
  prompt: Partial<GeneratePrompt> & { generation_type: GeneratePrompt['generation_type'] },
) => {
  switch (prompt.generation_type) {
    case ChannelType.CaseStudy:
      return prompt.product_name
    case ChannelType.NurtureEmailSequence:
    case ChannelType.PromotionalEmailSequence:
      return prompt.goal
    default:
      return shouldRenderPrompt(prompt.topic) ? prompt.topic : ''
  }
}
